import { render } from "./Trap.vue?vue&type=template&id=f54bdfbe"
import script from "./Trap.vue?vue&type=script&lang=js"
export * from "./Trap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Trap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f54bdfbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f54bdfbe', __exports__)) {
    api.reload('f54bdfbe', __exports__)
  }
  
  module.hot.accept("./Trap.vue?vue&type=template&id=f54bdfbe", () => {
    api.rerender('f54bdfbe', render)
  })

}


export default __exports__